import React from 'react';
import { Button, IconButton, Theme, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export interface IProps {
  className?: any;
  disabled?: boolean;
  backButtonStyle?: string;
  onClick: () => void;
  buttonLabel?: string;
  forceTitle?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  textSecondary: {
    color: theme.palette.text.secondary,
  },
  textBlue: {
    color: theme.palette.primary.main,
    fontSize: 15,
    lineHeight: '120%',
    fontWeight: 500,
    letterSpacing: '0.003em',
    textTransform: 'uppercase',
  },
}));

const BackButton: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { classes, cx } = useStyles();
  const [t] = useTranslation();
  const {
    backButtonStyle = 'default',
    buttonLabel = t('common:button.back'),
    forceTitle = false,
    className,
    ...rest
  } = props;
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const buttonStyle = backButtonStyle === 'blue' ? classes.textBlue : classes.textSecondary;
  if (isMobile && !forceTitle)
    return (
      <IconButton className={cx(buttonStyle, className || '')} {...rest} size="large">
        <ArrowBackIosIcon />
      </IconButton>
    );

  return (
    <Button className={buttonStyle} {...rest}>
      <ArrowBackIosIcon /> {buttonLabel}
    </Button>
  );
};

export default BackButton;
